import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';

import { type FormDetailsDefinition } from './form-details.definition';

export class FormDetailsDefinitionMapper implements DefinitionMapper<'formDetails'> {
  readonly type = 'formDetails';

  extract(element: CanvasElementFrom<'formDetails'>): PartialDeep<FormDetailsDefinition> {
    const content = element.props.content;

    return {
      $type: 'formDetails',
      title: content.title.label,
      showTitle: content.title.enabled,
      iconName: content.title.icon,
      layout: {
        $type: 'auto',
        visibleFields: [],
        columnCount: content.options?.columnsCount,
      },
    };
  }
}
